var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "center" },
    [
      _c(
        "el-col",
        { staticClass: "flex", attrs: { span: 2 } },
        [
          _c("app-display", {
            attrs: {
              label: "Nome do Interessado:",
              content: _vm.processo.nomeRazaoSocialInteressado
            }
          }),
          _c("app-display", {
            attrs: {
              label: "Número do processo SiCARF:",
              content: _vm.processo.numeroProcesso
            }
          }),
          _vm.isCCR
            ? _c("app-display", {
                attrs: {
                  label: "Número do título:",
                  content: _vm.numeroTituloDominial
                }
              })
            : _vm._e(),
          _vm.isCCR
            ? _c("app-display", {
                attrs: {
                  label: "Número do processo físico:",
                  content: _vm.numeroProcessoFisico
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-col",
        { staticClass: "flex", attrs: { span: 2 } },
        [
          _c("app-display", {
            attrs: {
              label: "CPF do Interessado:",
              content: _vm.processo.cpfCnpjInteressado
            }
          }),
          _c("app-display", {
            attrs: {
              label: "Tipo de Processo:",
              content: _vm.processo.tipo.nome || _vm.processo.tipo
            }
          }),
          _vm.isCCR
            ? _c("app-display", {
                attrs: {
                  label: "Data de emissão do título:",
                  content: _vm.formatDate(_vm.dataEmissaoTituloDominial)
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-col",
        { staticClass: "right", attrs: { span: 2 } },
        [
          _vm.showBotaoOpcoesHeader
            ? _c("app-opcoes-header-analise", {
                attrs: {
                  idProcesso: _vm.processo.id,
                  numeroProcesso: _vm.processo.numeroProcesso,
                  tipoProcesso: _vm.processo.tipo.codigo,
                  statusProcesso: _vm.processo.status,
                  protocolo: _vm.processo.numeroProtocolo,
                  idDespacho: _vm.dadosCadastros.despacho.id,
                  emRetificacao: _vm.processo.retificacao,
                  btnPendencia: _vm.visualizarBotaoSinalizarPendencia,
                  btnSolicitarInformacao: _vm.showSolicitarInformacoes()
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d5ddeed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5ddeed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeaderDadosProcesso.vue
// module id = null
// module chunks = 